// import RepositoryFactory from "@/apis";
import { reject } from "lodash";
// const services = RepositoryFactory.services;
import services from "../../apis/services";

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await services.create(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.delete(payload);

        // Update user details
        // console.log(data);
        commit("DELETE_Service", data.data);
        // console.log(data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  edit({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.edit(payload);

        // Update user details
        commit("SELECT_Service", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.get_all(payload);

        commit("GETALL_Service_Card", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_service({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.get(payload);

        commit("GET_Service", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  //partner apis

  createpartner({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await services.createpartner(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deletepartner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deletepartner(payload);

        // Update user details
        commit("DELETE_Partner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editpartner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.editpartner(payload);

        // Update user details
        commit("SELECT_Partner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getpartner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getpartner(payload);

        commit("GETALL_Partner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  //workshop
  createworkshop({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await services.createworkshop(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteworkshop({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deleteworkshop(payload);

        // Update user details
        commit("DELETE_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editworkshop({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.editworkshop(payload);

        // Update user details
        commit("SELECT_Workshop", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getworkshop({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getworkshop(payload);

        commit("GETALL_Workshop", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  //banner
  createbanner({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await services.createbanner(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deletebanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deletebanner(payload);

        // Update user details
        commit("DELETE_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.editbanner(payload);

        // Update user details
        commit("SELECT_Banner", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getbanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getbanner(payload);

        commit("GETALL_Banner", data.data.reverse());
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  //homebanner
  createhomebanner({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await services.createhomebanner(payload);
        // commit("ADD_BOOKING", payload);
        resolve(payload);
      } catch (error) {
        reject(error);
      }
    });
  },
  deletehomebanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deletehomebanner(payload);

        // Update user details
        commit("DELETE_Bannerhome", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  edithomebanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.edithomebanner(payload);

        // Update user details
        commit("SELECT_Bannerhome", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getallhomebanner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getallhomebanner(payload);

        commit("GETALL_Bannerhome", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  createregform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.createregform(payload);

        commit("SET_REG_FORM", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createCareProf({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.createCareProf(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCareProfs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getCareProfs(payload);
        commit("GET_CARE_PROFS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAppForm({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getAppForm(payload);
        commit("GET_APP_FORM", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createAppForm({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.createAppForm(payload);
        // commit("GET_CARE_PROFS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteAppForm({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deleteAppForm(payload);
        // commit("GET_CARE_PROFS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////////
  ////////////////////////////DONORS//////////////////////////////////
  /////////////////////////////////////////////////////////////////////
  getDonor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getDonor(payload);
        commit("GET_DONORS", data.data[0]);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  donorType({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.donorType(payload);
        commit("GET_DONOR_TYPE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createDonor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.createDonor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateDonor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.updateDonor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteDonor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deleteDonor(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////////
  ////////////////////////////WISHES//////////////////////////////////
  /////////////////////////////////////////////////////////////////////
  getWishes({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.getWishes(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  addWishes({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.addWishes(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editWishes({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.editWishes(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteWishes({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await services.deleteWishes(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
